import {styled} from 'styled-components'

export const HotspotImageContainer = styled.div`
  position: relative;
  width: 100%;
`
